import React, { useState, useEffect } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import axios from 'axios';

const FetchCount = ({ apiUrl, token }) => {
  const [count, setCount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchCount = async () => {
      try {
        setLoading(true);
        const response = await axios.get(apiUrl, {
          headers: {
            Authorization: `Bearer ${token}`, // Set the token in the Authorization header
          },
        });
        setCount(response.data.count); // Assuming the API returns the count in response.data.count
      } catch (error) {
        setError('Failed to fetch count');
      } finally {
        setLoading(false);
      }
    };

    fetchCount();
  }, [apiUrl, token]);

  if (loading) {
    return <CircularProgress style={{width:'10px',height:"10px", marginLeft:"10px" }} />;
  }

  if (!error) {
    return <Typography variant="caption" style={{
      color: 'white',
      backgroundColor: 'red',
      padding: '2px 8px',
      borderRadius: '50%',
      fontWeight: 'bold',
      display: 'inline-block', // keeps it tight to content width
      textAlign: 'center',
    }}>{count}</Typography>;
  }
  return <Typography variant="caption" style={{
    color: 'white',
    backgroundColor: 'red',
    padding: '2px 8px',
    borderRadius: '50%',
    fontWeight: 'bold',
    display: 'inline-block', // keeps it tight to content width
    textAlign: 'center',
  }}>0</Typography>;

}
FetchCount.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired, // Require token prop to be a string
};

export default FetchCount;
